import getAuth0ProviderDetails from "api-helpers/getAuth0ProviderDetails.ts";
import SentryErrorBoundary from "components/Error/SentryErrorBoundary";
import KaboodleRoot from "components/KaboodleRoot";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { initSentry } from "utils/sentry";
import { initLogDna } from "utils/log-utils";
import { Auth0Provider } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";

// initialize Sentry
initSentry();

// initialize LogDNA
initLogDna();

export const MainApp = () => {
  const [auth0, setAuth0] = useState(null);

  const onRedirectCallback = () => {
    const returnTo = localStorage.getItem("returnTo");
    if (returnTo) {
      localStorage.removeItem("returnTo");
    }
    window.history.replaceState(
      {},
      document.title,
      returnTo || window.location.pathname,
    );
    window.location.reload();
  };

  useEffect(() => {
    const fetchAuth0Details = async () => {
      try {
        const details = await getAuth0ProviderDetails();
        setAuth0(details);
      } catch (error) {
        console.error("There was an error fetching Auth0 details", error);
      }
    };

    fetchAuth0Details();
  }, []);

  // Render based on auth0 state
  if (!auth0) {
    return null;
  }

  return (
    <Sentry.ErrorBoundary fallback={<SentryErrorBoundary />}>
      <Auth0Provider
        domain={auth0.AUTH0_DOMAIN}
        clientId={auth0.AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: auth0.AUTH0_AUDIENCE,
          scope: "openid profile email offline_access",
        }}
        onRedirectCallback={onRedirectCallback}
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
        cacheLocation="localstorage"
      >
        <DndProvider backend={HTML5Backend}>
          <KaboodleRoot />
        </DndProvider>
      </Auth0Provider>
    </Sentry.ErrorBoundary>
  );
};

ReactDOM.createRoot(document.getElementById("kaboodle-react-app")!).render(
  <MainApp />,
);
